<template>
  <div class="bank-card-dialog">
    <custom-dialog :title="model.title" :appendToBody="true" :visible="visible" width="510px" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="bankCardForm" :rules="rules" :validate-on-rule-change="false" ref="bankCardForm">
          <el-form-item :label="$t('bank_cards_dialog.kai_hu_ming')" prop="depositName">
            <el-input v-model="bankCardForm.depositName" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('bank_cards_dialog.yin_hang_zhang_hao')" prop="depositNumber">
            <el-input v-model="bankCardForm.depositNumber" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('bank_cards_dialog.kai_hu_yin_hang')" prop="depositBank">
            <el-input v-model="bankCardForm.depositBank" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('bank_cards_dialog.zhang_hu_lei_xing')" prop="depositType">
            <custom-select v-model="bankCardForm.depositType" code="bank_deposit_type" :placeholder="$t('Common.com_please_select')" style="width: 460px"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('bank_cards_dialog.miao_shu')" prop="bankcardDesc">
            <el-input type="textarea" :rows="3" v-model="bankCardForm.bankcardDesc" style="width: 460px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="warning" @click="addAddress">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      bankCardForm: {
        // bankCode: '', // 开户行
        bankName: '', // 开户行名称
        depositName: '', // 账户名称
        depositNumber: '', // 账号
        depositBank: '', // 支行名称
        depositType: '', // 账号类型
        bankcardId: '',
        depositPurpose: [], // 账户类型(传空 不用了)
        bankcardDesc: '', // 账户用途
        partnerId: '', // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
        partnerOrgId: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        depositName: [
          {
            required: true,
            message: this.$t('bank_cards_dialog.kai_hu_ming_bi_tian'),
          },
          { max: 50, message: ' ' },
        ], // 账户名称
        depositNumber: [
          {
            required: true,
            message: this.$t('bank_cards_dialog.yhzhbt'),
          },
          { max: 30, message: ' ' },
        ], // 账号
        depositBank: [
          {
            required: true,
            message: this.$t('bank_cards_dialog.khyhbt'),
          },
          { max: 50, message: ' ' },
        ], // 支行名称
        depositType: [
          {
            required: true,
            message: this.$t('bank_cards_dialog.zhlxbx'),
          },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
      if (this.model.partnerOrgId) {
        // this.bankCardForm.partnerOrgId = this.model.partnerOrgId;
      } else {
        this.bankCardForm.partnerOrgId = this.$store.state.userInfo.rootOrgId;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.bankCardForm, this.model.data.item);
        // 后端返回的是数组字符串
        this.bankCardForm.depositPurpose = this.model.data.item.depositPurpose ? JSON.parse(this.model.data.item.depositPurpose) : [];
      }
    },
    onBankCode(item) {
      this.bankCardForm.bankName = item.bankName;
    },
    // 保存基本信息
    addAddress: function () {
      this.$refs.bankCardForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.$putJSON(apis.partnerBankcardUpdate, this.bankCardForm).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.visible = false;
            this.$emit('success');
          });
        } else if (this.model.partnerId) {
          //   // 合作伙伴
          //   this.$postJSON(apis.PartnerBankcardAddByOrgId, this.bankCardForm).then((res) => {
          //     this.$message({
          //       message: '操作成功',
          //       type: 'success'
          //     });
          //     this.visible = false;
          //     this.$emit('success');
          //   });
        } else {
          // 自己
          this.$postJSON(apis.partnerBankcardAdd, this.bankCardForm).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.visible = false;
            this.$emit('success');
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.bank-card-dialog {
  .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 24px;
    .tag {
      width: 4px;
      height: 15px;
      background-color: #00afff;
      left: 0;
    }
  }
}
</style>
